import { render, staticRenderFns } from "./RegisterController.vue?vue&type=template&id=800a094c&scoped=true"
import script from "./RegisterController.vue?vue&type=script&lang=js"
export * from "./RegisterController.vue?vue&type=script&lang=js"
import style0 from "./RegisterController.vue?vue&type=style&index=0&id=800a094c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800a094c",
  null
  
)

export default component.exports